'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("choixTicketPopinController", function ($scope, $http, $q, lovService) {
  $http.get('/rest/echange/ticket-list-recents', {
    params: {
      compteId: $scope.compteId
    }
  }).then(function (result) {
    $scope.tickets = result.data;
  });
  $scope.ticketsTableConfig = {
    source: "tickets",
    allowSelection: true,
    selectionAttribute: "ticket",
    selectionScope: $scope,
    columns: [{
      title: "Titre",
      attribute: "titre",
      sortable: true
    }, {
      title: "Statut",
      attribute: "statutTicket",
      template: "{{'lov.taskStatuts.'+model.statutTicket|translate}}",
      sortable: true
    }, {
      title: "Type",
      attribute: "typeTicket",
      template: "{{'lov.typeTickets.'+model.typeTicket|translate}}",
      sortable: true
    }, {
      title: 'Date début',
      id: 'dateDebutTicket',
      attribute: 'dateDebutTicket',
      filter: "dateShort",
      sortable: true,
      sortType: "date"
    }, {
      title: 'Date fin',
      id: 'dateFinTicket',
      attribute: 'dateFinTicket',
      filter: "dateShort",
      sortable: true,
      sortType: "date"
    }]
  };
  $scope.saveAndClose = function () {
    $scope.$close($scope.ticket);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/choixTicket/choixTicketPopinController.js
// module id = 2887
// module chunks = 13